import { noop } from '@direct-frontend/stdlib';
import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    type OpenApiGetHostInfoRequest,
    type OpenApiGetHostInfoResponseSuccess,
    type OpenApiVerificateHostRequest,
    type OpenApiVerificateHostResponseSuccess,
} from '#shared/api/schema';

const api = createApi({
    name: 'entities/integration/api/webmasterApi',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            getHostInfo: builder.query<OpenApiGetHostInfoResponseSuccess, OpenApiGetHostInfoRequest>({
                query: () => {
                    return {
                        url: '/webmaster/yandex/host/verification',
                        method: 'GET',
                    };
                },
            }),
            verify: builder.mutation<OpenApiVerificateHostResponseSuccess, OpenApiVerificateHostRequest>({
                query: () => {
                    return {
                        url: '/webmaster/yandex/host/verification',
                        method: 'POST',
                        body: {},
                    };
                },
                onQueryStarted: async (_, { queryFulfilled }) => {
                    const queryFulfilledResult = await queryFulfilled.catch(noop);

                    if (queryFulfilledResult === undefined) {
                        return;
                    }

                    const { data: newData } = queryFulfilledResult;

                    api.endpoints.getHostInfo.updateQueryData(undefined, (oldData) => {
                        return { ...oldData, ...newData };
                    });
                },
            }),
        };
    },
});

export const useIntegrationGetWebmasterHostInfo = api.useGetHostInfoQuery;
export const addIntegrationWebmaster = api.endpoints.verify.mutate;
